import React, { useEffect, useState } from 'react';

function OrderConfirmation({ orderData, setCurrentPage }) {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    const redirectTimer = setTimeout(() => {
      setCurrentPage('home');
    }, 5000);

    return () => {
      clearInterval(timer);
      clearTimeout(redirectTimer);
    };
  }, [setCurrentPage]);

  const totalPrice = orderData.items.reduce((sum, item) => sum + item.price, 0);

  return (
    <main className="order-confirmation">
      <div className="confirmation-container">
        {/* Success Header */}
        <div className="success-header">
          <div className="success-icon">✅</div>
          <h2>Order Confirmed!</h2>
          <p className="order-id">Order ID: <strong>#{Math.random().toString(36).substr(2, 9).toUpperCase()}</strong></p>
        </div>

        {/* Customer Info */}
        <div className="confirmation-section">
          <h3>📋 Order Details</h3>
          <div className="detail-row">
            <span>Name:</span>
            <strong>{orderData.customerName}</strong>
          </div>
          <div className="detail-row">
            <span>Phone:</span>
            <strong>{orderData.customerPhone}</strong>
          </div>
          <div className="detail-row">
            <span>Email:</span>
            <strong>{orderData.customerEmail}</strong>
          </div>
          <div className="detail-row">
            <span>Delivery Address:</span>
            <strong>{orderData.deliveryAddress}</strong>
          </div>
        </div>

        {/* Items Summary */}
        <div className="confirmation-section">
          <h3>🛍️ Items Ordered</h3>
          <div className="items-list">
            {orderData.items.map((item, idx) => (
              <div key={idx} className="item-row">
                <span>{item.productName}</span>
                <span className="item-price">₹{item.price}</span>
              </div>
            ))}
          </div>
          <div className="items-total">
            <strong>Total Amount:</strong>
            <strong className="total">₹{totalPrice}</strong>
          </div>
        </div>

        {/* Next Steps */}
        <div className="confirmation-section info-section">
          <h3>📞 What's Next?</h3>
          <ul className="next-steps">
            <li>✓ Our team will call you within 1 hour to confirm your order</li>
            <li>✓ Payment will be collected at delivery (Cash on Delivery)</li>
            <li>✓ Your order will be delivered within 24-48 hours</li>
            <li>✓ You will receive SMS and email updates</li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="confirmation-section contact-section">
          <h3>📧 Need Help?</h3>
          <p>If you have any questions, contact us:</p>
          <div className="contact-details">
            <p><strong>📱 Phone:</strong> 8401477362</p>
            <p><strong>✉️ Email:</strong> dishamedicalstore9@gmail.com</p>
          </div>
        </div>

        {/* Redirect Info */}
        <div className="redirect-info">
          <p>Redirecting to home in <strong>{countdown}s</strong>...</p>
          <button onClick={() => setCurrentPage('home')} className="btn-home">
            Back to Home
          </button>
        </div>
      </div>
    </main>
  );
}

export default OrderConfirmation;